// src/app/core/services/config.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export interface AppConfig {
    appName: string;
    title: string;
    description: string;
    url: string;
    logo: string;
    favicon: {
        ico: string;
        png96: string;
        apple180: string;
    };
    twitter: {
        card: string;
        site: string;
        creator: string;
    };
    og: {
        locale: string;
        type: string;
    };
}

@Injectable({
    providedIn: 'root'
})
export class ConfigAppService {
    private configUrl = 'assets/config/app-config.json';
    private config$: Observable<AppConfig>;

    constructor(private http: HttpClient) { }

    loadConfig(): Observable<AppConfig> {
        if (!this.config$) {
            this.config$ = this.http.get<AppConfig>(this.configUrl).pipe(
                shareReplay(1),
                catchError(err => {
                    console.error('Error cargando configuración', err);
                    // Fallback básico
                    return of({
                        appName: 'UtuShp',
                        title: 'PDV',
                        description: 'Sistema de ventas de Productos',
                        url: window.location.origin,
                        logo: 'assets/img/logo.png',
                        favicon: {
                            ico: '/favicon.ico',
                            png96: '/favicon-32x32.png',
                            apple180: '/apple-touch-icon.png'
                        },
                        twitter: { card: 'summary', site: '', creator: '' },
                        og: { locale: 'es_AR', type: 'website' }
                    });
                })
            );
        }
        return this.config$;
    }

    getConfig(): Observable<AppConfig> {
        return this.loadConfig();
    }
}